import { useState } from "react";
import MobileMenu from "./MobileMenu";

const Navbar = (props) => {
  const { menuOpen, setMenuOpen } = props;

  const handleScroll = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full h-[68px] flex items-center justify-center p-5 md:h-auto z-[9999] bg-black/70 backdrop-blur-md">
      <div className="w-[718px] flex items-center justify-between gap-5 md:w-full sm:flex-col">
        <a href="#"><img src="/images/logo.svg" alt="logo" className="w-[26px] h-[26px] object-contain" /></a>
        <ul className="mobile:hidden flex flex-wrap gap-8">
          <li>
            <a href="#About" className="cursor-pointer" onClick={(e) => handleScroll(e, "About")}>
              <p className="size-text4xl heading ui !font-monasans">About</p>
            </a>
          </li>
          <li>
            <a href="#Programs" className="cursor-pointer" onClick={(e) => handleScroll(e, "Programs")}>
              <p className="size-text4xl heading ui !font-monasans">Programs</p>
            </a>
          </li>
          <li>
            <a href="#Sponsors" className="cursor-pointer" onClick={(e) => handleScroll(e, "Sponsors")}>
              <p className="size-text4xl heading ui !font-monasans">Sponsors</p>
            </a>
          </li>
          <li>
            <a href="https://secure.touchnet.net/C20832_ustores/web/store_main.jsp?STOREID=178&SINGLESTORE=true" className="cursor-pointer">
              <p className="size-text4xl heading ui !font-monasans">Tickets</p>
            </a>
          </li>
          <li>
            <a href="https://www.harvardxr.com/" className="cursor-pointer">
              <p className="size-text4xl heading ui !font-monasans">HarvardXR 2024</p>
            </a>
          </li>
        </ul>
      </div>

      <div className="absolute inset-0 bg_nav_pc h-[1px] top-[68px] "></div>

      {/* 햄버거 메뉴 (모바일) */}
      <img src="/images/hamburger.png" className="w-[36px] h-[36px] desktop:hidden tablet:hidden text-2xl text-white" onClick={() => setMenuOpen(!menuOpen)} />
    </header>
  );
};

export default Navbar;
